import React, { useEffect, useState, useRef } from "react";
import InnerImageZoom from "react-inner-image-zoom";
import "react-inner-image-zoom/lib/InnerImageZoom/styles.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/grid";
import "swiper/css/navigation";
import "./DarkCard.scss";

import {
  Autoplay,
  FreeMode,
  Grid,
  Navigation,
  Pagination,
} from "swiper/modules";

const getGradeColor = (grade) => {
  if (grade === 3) return "bg-[#f05a4f] text-white"; // 90 - 95 -> Red
  if (grade === 2) return "bg-[#FEC84B] text-black"; // 85 - 89 -> Yellow
  if (grade === 1) return "bg-[#54d992] text-black"; // 80 - 84 -> Green
  return "bg-gray-300"; // Default (if needed)
};

let i = 0;

const chunkArray = (array, size) => {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

const MonitorCard = ({
  data,
  filletInfo,
  gridRows,
  playFilletSlider,
  swiperRef,
  viewMode,
  rowPerView,
  navigation,
  sliderType,
  isPlaying,
  filletInformation,
  direction,
  setSelectedPageIdx,
  setIsPlaying,
  setPreviousView,
  selectedMonitor,
  setSelectedMonitor,
  nextPage,
  prevPage,
  isPidExist,
  isLoading
}) => {
  const itemsPerPage = rowPerView * gridRows;
  const chunked = chunkArray(data, itemsPerPage); // 2 rows x 2 columns
  const startX = useRef(null);

  const handleTouchStart = (e) => {
    startX.current = e.touches[0].clientX;
  };

  const handleTouchEnd = (e) => {
    const endX = e.changedTouches[0].clientX;
    detectSwipe(endX);
  };

  const handleMouseDown = (e) => {
    startX.current = e.clientX;
  };

  const handleMouseUp = (e) => {
    detectSwipe(e.clientX);
  };

  const detectSwipe = (endX) => {
    const delta = startX.current - endX;
    const threshold = 50;
    if (delta > threshold) prevPage();
    else if (delta < -threshold) nextPage();
    else console.log("Swipe too short");
  };

  return (
    <div
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      <Swiper
        ref={swiperRef}
        modules={[Autoplay, FreeMode, Grid, Navigation, Pagination]}
        spaceBetween={10}
        slidesPerView={sliderType === "hSlider" ? 1 : rowPerView}
        speed={sliderType === "rSlider" ? 100 : 5000}
        freeMode={{ enabled: false, sticky: false }}
        className="py-3"
        autoplay={false}
        style={{ width: "100%", zIndex: 0 }}
        cssMode={false}
        allowTouchMove={false}
        dir={direction}
        key={direction || data}
        grid={{ rows: 1, fill: "row" }}
        navigation={{
          enabled: navigation,
          prevEl: ".chevronleft",
          nextEl: ".chevronright",
        }}
        pagination={{ clickable: true }}
        // initialSlide={data.length}
      >
        {sliderType === "hSlider"
          ? chunked.map((group, index) => (
              <SwiperSlide style={{ zIndex: 0 }} key={index}>
                <div
                  className={`grid ${viewMode === 1 && "grid-cols-1 md:grid-cols-2 lg:grid-cols-4"} ${viewMode === 2 && "grid-cols-1 md:grid-cols-1 lg:grid-cols-1"} ${viewMode === 3 && "grid-cols-1 md:grid-cols-1 lg:grid-cols-1"} gap-2`}
                >
                  {group.map((monitor, idx) => {
                    return (
                      <div
                        key={idx}
                        onClick={() => {
                          filletInfo(monitor.processedProductID, "hswiper");
                          setSelectedPageIdx(idx);
                          setIsPlaying(false);
                          setPreviousView({ prev: null, page: null });
                          setSelectedMonitor(monitor);
                        }}
                        className={`w-[100%] min-h-24 flex flex-col justify-between relative border-gray-400 ${monitor.processedProductID === filletInformation?.filletDetails?.processedProductID ? "border-2" : "border"} ${viewMode === 1 && "h-[240px]"} ${viewMode === 3 && "h-350"} rounded-md bg-gray-50 overflow-hidden`}
                      >
                        {/* Header */}
                        <div
                          className={`w-full p-3 flex items-center justify-between border-b border-gray-200  ${viewMode === 1 ? "flex-col" : "flex-row"}`}
                        >
                          <p className="mb-0 text-[11px] text-[#475467]">
                            PID: {monitor.processedProductID}
                          </p>
                          <p className="mb-0 text-[11px] text-[#475467]">
                            {monitor?.validFromUTC?.split("T")[0]}{" "}
                            {monitor?.validFromUTC?.split("T")[1].split(":")[0]}
                            :
                            {monitor?.validFromUTC?.split("T")[1].split(":")[1]}{" "}
                            UTC
                          </p>
                        </div>

                        {/* Image with Zoom Effect */}

                        {viewMode === 1 &&
                          monitor.processedProductImage.map((data) => {
                            return (
                              data.imageType === "Single" && (
                                <ImageMagnifier
                                  src={`${data.url}`}
                                  key={data.url}
                                  className={`w-[250px] lg:w-[300px] xl:w-[250px]`}
                                  magnifierHeight={400}
                                  magnifierWidth={400}
                                  zoomLevel={2}
                                  alt={`${data.url}`}
                                  isPlaying={isPlaying}
                                />
                              )
                            );
                          })}

                        {/* <div className="flex flex-row w-full">
                          {viewMode === 2 &&
                            monitor.processedProductImage.map((data) => {
                              return (
                                <>
                                  <img
                                    key={data.url}
                                    src={data.url}
                                    // width={"100%"}
                                  />
                                </>
                              );
                            })}
                        </div> */}
                        <div className="flex flex-col-reverse justify-center items-center gap-1 overflow-hidden">
                          {viewMode === 2 &&
                          monitor?.processedProductImage?.find((data) =>
                            data?.imageType?.includes("Dual")
                          )
                            ? monitor?.processedProductImage.map((data) => {
                                return (
                                  <>
                                    {data.imageType === "Single" && (
                                      <ImageMagnifier
                                        src={`${data.url}`}
                                        key={data.url}
                                        className={`w-[100%]`}
                                        magnifierHeight={400}
                                        magnifierWidth={400}
                                        zoomLevel={2}
                                        alt={`${data.url}`}
                                        isPlaying={isPlaying}
                                      />
                                    )}
                                    {data.imageType === "Dual" && (
                                      <ImageMagnifier
                                        src={`${data.url}`}
                                        key={data.url}
                                        className={`w-[100%]`}
                                        magnifierHeight={400}
                                        magnifierWidth={400}
                                        zoomLevel={2}
                                        alt={`${data.url}`}
                                        isPlaying={isPlaying}
                                      />
                                    )}
                                  </>
                                );
                              })
                            : viewMode === 2 && (
                                <div className="h-24 flex justify-center items-center">
                                  <p>Dual view not available</p>
                                </div>
                              )}
                        </div>
                        <div className="flex flex-col-reverse justify-center items-center gap-1 overflow-hidden">
                          {viewMode === 3 &&
                          monitor?.processedProductImage?.find((data) =>
                            data?.imageType?.includes("Triple")
                          ) &&
                          monitor?.processedProductImage?.find((data) =>
                            data?.imageType?.includes("Dual")
                          )
                            ? monitor?.processedProductImage?.map((data) => {
                                return (
                                  <>
                                    {data.imageType === "Single" && (
                                      <ImageMagnifier
                                        src={`${data.url}`}
                                        key={data.url}
                                        className={`w-[100%]`}
                                        magnifierHeight={400}
                                        magnifierWidth={400}
                                        zoomLevel={2}
                                        alt={`${data.url}`}
                                        isPlaying={isPlaying}
                                      />
                                    )}
                                    {data.imageType === "Dual" && (
                                      <ImageMagnifier
                                        src={`${data.url}`}
                                        key={data.url}
                                        className={`w-[100%]`}
                                        magnifierHeight={400}
                                        magnifierWidth={400}
                                        zoomLevel={2}
                                        alt={`${data.url}`}
                                        isPlaying={isPlaying}
                                      />
                                    )}
                                    {data.imageType === "Triple" && (
                                      <ImageMagnifier
                                        src={`${data.url}`}
                                        key={data.url}
                                        className={`w-[100%]`}
                                        magnifierHeight={400}
                                        magnifierWidth={400}
                                        zoomLevel={2}
                                        alt={`${data.url}`}
                                        isPlaying={isPlaying}
                                      />
                                    )}
                                  </>
                                );
                              })
                            : viewMode === 3 && (
                                <div className="h-24 flex justify-center items-center">
                                  <p>Triple view not available</p>
                                </div>
                              )}
                        </div>

                        {/* Footer */}
                        <div
                          className={`absolute bottom-0 w-full p-2 flex items-center justify-between ${getGradeColor(monitor.grading)}`}
                        >
                          <p className="mb-0 text-[12px] text-black">
                            Colour Grading
                          </p>
                          <p className="mb-0 text-[11px] text-[#101828] font-bold">
                            {monitor.grading}
                          </p>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </SwiperSlide>
            ))
          : data.map((monitor, index) => (
              <SwiperSlide style={{ zIndex: 0 }} key={index}>
                <div
                  onClick={() => {
                    filletInfo(monitor.processedProductID);
                    setSelectedPageIdx(null);
                  }}
                  className={`w-[100%] min-h-24 flex flex-col justify-between relative border-gray-400 ${monitor.processedProductID === filletInformation?.filletDetails?.processedProductID ? "border-2" : "border"} ${viewMode === 1 && "h-[240px]"} ${viewMode === 3 && "h-350"} rounded-md bg-gray-50 overflow-hidden`}
                >
                  {/* Header */}
                  <div
                    className={`w-full p-3 flex items-center justify-between border-b border-gray-200 ${viewMode === 1 ? "flex-col" : "flex-row"}`}
                  >
                    <p className="mb-0 text-[11px] text-[#475467]">
                      PID: {monitor.processedProductID}
                    </p>
                    <p className="mb-0 text-[11px] text-[#475467]">
                      {monitor?.validFromUTC?.split("T")[0]}{" "}
                      {monitor?.validFromUTC?.split("T")[1].split(":")[0]}:
                      {monitor?.validFromUTC?.split("T")[1].split(":")[1]} UTC
                    </p>
                  </div>

                  {/* Image with Zoom Effect */}

                  {viewMode === 1 &&
                    monitor.processedProductImage.map((data) => {
                      return (
                        data.imageType === "Single" && (
                          <ImageMagnifier
                            src={`${data.url}`}
                            key={data.url}
                            // width={300}
                            // height={300}
                            className={`w-[250px] lg:w-[300px] xl:w-[250px]`}
                            magnifierHeight={400}
                            magnifierWidth={400}
                            zoomLevel={2}
                            alt={`${data.url}`}
                            isPlaying={isPlaying}
                          />
                        )
                      );
                    })}

                  {viewMode === 2 &&
                    monitor.processedProductImage.map((data) => {
                      return (
                        data.imageType === "Dual" && (
                          <img key={data.url} src={data.url} width={"100%"} />
                        )
                      );
                    })}
                  {viewMode === 3 &&
                    monitor.processedProductImage.map((data) => {
                      return (
                        data.imageType === "Triple" && (
                          <img key={data.url} src={data.url} width={"100%"} />
                        )
                      );
                    })}

                  {/* Footer */}
                  <div
                    className={`absolute bottom-0 w-full p-2 flex items-center justify-between ${getGradeColor(monitor.grading)}`}
                  >
                    <p className="mb-0 text-[12px] text-black">
                      Colour Grading
                    </p>
                    <p className="mb-0 text-[11px] text-[#101828] font-bold">
                      {monitor.grading}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
      </Swiper>
    </div>
  );
};

export default MonitorCard;

export const ImageMagnifier = ({
  src,
  className,
  width,
  height,
  alt,
  magnifierHeight = 150,
  magnifierWidth = 150,
  zoomLevel = 3,
  isPlaying,
}) => {
  const [showMagnifier, setShowMagnifier] = useState(false);
  const [[imgWidth, imgHeight], setSize] = useState([0, 0]);
  const [[x, y], setXY] = useState([0, 0]);

  const mouseEnter = (e) => {
    const el = e.currentTarget;

    const { width, height } = el.getBoundingClientRect();
    setSize([width, height]);
    setShowMagnifier(true);
  };

  const mouseLeave = (e) => {
    e.preventDefault();
    setShowMagnifier(false);
  };

  const mouseMove = (e) => {
    const el = e.currentTarget;
    const { top, left } = el.getBoundingClientRect();

    const x = e.pageX - left - window.scrollX;
    const y = e.pageY - top - window.scrollY;

    setXY([x, y]);
  };

  return (
    <div className="relative inline-block h-full overflow-hidden">
      <div className="flex w-full justify-center items-center h-full overflow-hidden">
        <img
          src={src}
          className={className}
          alt={alt}
          onMouseEnter={(e) => mouseEnter(e)}
          onMouseLeave={(e) => mouseLeave(e)}
          onMouseMove={(e) => mouseMove(e)}
          loading="lazy"
        />
      </div>
      {!isPlaying && (
        <div
          style={{
            display: showMagnifier ? "" : "none",
            position: "absolute",
            pointerEvents: "none",
            height: `${magnifierHeight}px`,
            width: `${magnifierWidth}px`,
            opacity: "1",
            border: "1px solid lightgrey",
            backgroundColor: "white",
            borderRadius: "5px",
            backgroundImage: `url('${src}')`,
            backgroundRepeat: "no-repeat",
            top: `${y - magnifierHeight / 2}px`,
            left: `${x - magnifierWidth / 2}px`,
            backgroundSize: `${imgWidth * zoomLevel}px ${imgHeight * zoomLevel}px`,
            backgroundPositionX: `${-x * zoomLevel + magnifierWidth / 2}px`,
            backgroundPositionY: `${-y * zoomLevel + magnifierHeight / 2}px`,
          }}
        />
      )}
    </div>
  );
};



